import { type AriaAttributes, type AriaRole } from 'react'
import { Portal } from '@/components/Portal'

export interface ScreenReaderAnnounceProps extends AriaAttributes {
  text?: string
  role?: AriaRole
}

/**
 * Announces content to screen readers only.
 */
export function ScreenReaderAnnounce({
  text = '',
  ...rest
}: ScreenReaderAnnounceProps) {
  return (
    <Portal>
      <div
        aria-live={rest.role ? undefined : 'polite'}
        aria-atomic
        {...rest}
        className="sr-only"
      >
        {text}
      </div>
    </Portal>
  )
}
